/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

async function downloadAndOpen(url) {
  const response = await fetch(url, { credentials: 'omit' });
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
}

const DownloadInMemoryLink = ({ url, children, style, ...props }) => {
  const handleDownload = useCallback(
    async (e) => {
      e.preventDefault();
      await downloadAndOpen(url);
    },
    [url]
  );

  const handleKeyDown = useCallback(
    async (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        await downloadAndOpen(url);
      }
    },
    [url]
  );

  return (
    <a
      href="#"
      role="button"
      tabIndex={0}
      onClick={handleDownload}
      onKeyDown={handleKeyDown}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        cursor: 'pointer',
        ...style,
      }}
      {...props}
    >
      {children}
    </a>
  );
};

DownloadInMemoryLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

DownloadInMemoryLink.defaultProps = {
  style: undefined,
};

export default DownloadInMemoryLink;
